var config = {
    api: {
        endpoint: 'https://api.mymoria.de',
    },
    cms: {
        endpoint: 'https://cms.mymoria.de/api/collections/get/',
    },
};
export default config;
//# sourceMappingURL=config.js.map